/**
=========================================================
* BASE: Learning Repository - v1.0.0
=========================================================

* Copyright 2022 Sean Dooley (https://www.dooley-dev.com)

Coded by www.dooley-dev.com

 =========================================================

* The above copyright notice shall be included in substantial portions of the Software.
*/
// React
import React from "react";
import { Link } from 'react-router-dom';
// BASE components
import BASESvgIcon from "../../../@BASE/core/BASESvgIcon";
// Material-UI components
import Divider from "@mui/material/Divider";
import LinearProgress from "@mui/material/LinearProgress";
import IconButton from "@mui/material/IconButton";
import Paper from "@mui/material/Paper";
import Typography from '@mui/material/Typography';

function StatusCard({ instance, steps, resource}) {

  if (!instance || !steps) {
    return null;
  }

  const handleStatusColor = (status) => {
    switch (status) {
      case 'not_started':
        return 'primary';
      case 'complete':
        return 'success';
      default:
        return 'secondary';
    }
  }

  return (
    <div className='w-full'>
      <div className="mb-32 space-y-16">
        <Typography className="grow text-2xl font-bold tracking-tight leading-none py-8">
          Status
        </Typography>
        <Divider />
        <Paper className="flex flex-col flex-auto p-24 shadow rounded-xl overflow-hidden">
          <div className="flex items-center justify-between">
            <div className="flex flex-col">
              <Typography className="text-lg font-medium tracking-tight leading-6 truncate">
                Progress
              </Typography>
              <Typography
                className="text-md font-medium"
                color="text.secondary"
              >
                {resource} Progress Snapshot
              </Typography>
            </div>
          </div>
          <div className="my-32 space-y-32">
            <div className="flex flex-col">
              <div className="flex items-center">
                <div className="flex items-center justify-center w-32 h-32 rounded">
                  <BASESvgIcon className="text-current">heroicons-outline:document-text</BASESvgIcon>
                </div>
                <div className="flex-auto leading-none">
                  <Typography
                    className="text-md font-medium mx-8"
                    color="text.secondary"
                  >
                    Storyboard Progress
                  </Typography>
                  <Typography className="font-medium text-lg px-8">
                    {steps[instance.status.development]?.label}
                  </Typography>
                  <LinearProgress
                    variant="determinate"
                    className="mt-12 mx-8"
                    color={handleStatusColor(instance.status.development)}
                    value={instance.progress.development}
                  />
                </div>
                {resource !== "Project" && (  
                  <div className="flex items-center justify-center w-32 h-32">
                    <IconButton 
                      to="status/development"
                      component={Link}
                      aria-label="Go to Storyboard Status"
                    >
                      <BASESvgIcon>heroicons-outline:arrow-sm-right</BASESvgIcon>
                    </IconButton>
                  </div>
                )}
              </div>
            </div>
            <div className="flex flex-col">
              <div className="flex items-center">
                <div className="flex items-center justify-center w-32 h-32 rounded">
                  <BASESvgIcon className="text-current">heroicons-outline:desktop-computer</BASESvgIcon>
                </div>
                <div className="flex-auto leading-none">
                  <Typography
                    className="text-md font-medium mx-8"
                    color="text.secondary"
                  >
                    Production Progress
                  </Typography>
                  <Typography className="font-medium text-lg px-8">
                    {steps[instance.status.production]?.label}
                  </Typography>
                  <LinearProgress
                    variant="determinate"
                    className="mt-12 mx-8"
                    color={handleStatusColor(instance.status.development)}
                    value={instance.progress.production}
                  />
                </div>
                {resource !== "Project" && (  
                  <div className="flex items-center justify-center w-32 h-32">
                    <IconButton 
                      to="status/production"
                      component={Link}
                      aria-label="Go to Storyboard Status"
                    >
                      <BASESvgIcon>heroicons-outline:arrow-sm-right</BASESvgIcon>
                    </IconButton>
                  </div>
                )}
              </div>
            </div>
          </div>
        </Paper>
      </div>
    </div>
  );
}

export default StatusCard;
